global.conmed = global.conmed || {};

conmed.formBtn = function ($) {
    'use strict';
    var that = {
        selectors: {
            
        }
    };

    that.init = function () {
        $(".conmed-form .standard-btn").wrap("<div class=\"standard-btn btn dark\"></div>");
        var btnDesign = "<div class=\"d-flex\"><div class=\"btn-slant-lines\"> <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 28.7 17.3\" style=\"enable-background:new 0 0 28.7 17.3;\" xml:space=\"preserve\"> <style type=\"text/css\"> .st0{fill:#000000;} </style> <g> <rect x=\"19.4\" y=\"-1.5\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 1.229882e-02 16.9046)\" class=\"st0\" width=\"2\" height=\"19.9\"/> <rect x=\"8.8\" y=\"-1.5\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -3.0867 9.4228)\" class=\"st0\" width=\"2\" height=\"19.9\"/> <rect x=\"2.8\" y=\"9.4\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -8.0639 6.4761)\" class=\"st0\" width=\"2\" height=\"7.1\"/> </g> </svg> </div></div><div class=\"btn-line\"><div class=\"slant\"></div></div>"
        $(".conmed-form input.form-submit").after(btnDesign);

        $('form').attr('data-ajax-loading', '.loading-spinner');
    };

    return that;
}(jQuery);